import { render, staticRenderFns } from "./notStart.vue?vue&type=template&id=4865f724&scoped=true&"
import script from "./notStart.vue?vue&type=script&lang=js&"
export * from "./notStart.vue?vue&type=script&lang=js&"
import style0 from "./notStart.vue?vue&type=style&index=0&id=4865f724&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4865f724",
  null
  
)

export default component.exports